import { apiClient } from '_app'
import { ApiResponse, VehicleRecallStatusDto } from 'dtos'

export const getVehicleRecallStatuses = () =>
  apiClient.get<ApiResponse<VehicleRecallStatusDto[]>>('/api/vehicle-recall-statuses').then(response => response.data)
